import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Drawer,Upload, Modal,message,Collapse, Radio,Checkbox,Select,label,Input,Popover, Button ,Tooltip,TimePicker   } from 'antd';
import { PlusOutlined,PictureOutlined,VideoCameraOutlined,FileOutlined,FileImageOutlined,CloseOutlined,AudioOutlined } from '@ant-design/icons';

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import load from '../../assets/images/icon/load.gif';

import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;
const selected_student = [];

function callback(key) {
  console.log(key);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			loading: false,  		 
			master_id: [],		
			student_id: '',		
			reports_master_list: [],		
			reports_data: [],		
			student_list: [],		
			reports_data_details: [],
			student_data_details: [],
			
		}
		this.handleSubmit = this.handleSubmit.bind(this);	
		this.goBack = this.goBack.bind(this);		
	}
	
	 
	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		this.checkData();
		}
	}	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ 
			 user_id : storedArray['data'][0]['user_id'], 
			 student_id : this.props.match.params.id, 
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
	
										
		    	var app = {user_id : user_id,school_id:school_id}			
				getData('fees/student_details_list',app).then((result) => {
						let responseJson = result;
						if(responseJson.data){
							if(result['status'] == 200){
								this.setState({
									student_list: result['data'],
									student_id: result['student_id'],
								});
							}else{
								this.setState({
									student_list: [],
								});
							}
						}
					});		
			
		    var app2 = {id : this.props.match.params.id,user_id:user_id,school_id:school_id}
			getData('fees/get_student_reports_data_details',app2).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){				
						this.setState({
							student_data_details: result['student'],
							reports_data_details: result['data'],
							student_id: result['student_id'],
						});
						
					}else{
						this.setState({
							student_data_details: [],
							reports_data_details: [],
						});
					}
				}
			});	
			
			
			
		  var app = {user_id : user_id,school_id:school_id,student_id: this.props.match.params.id}
			getData('fees/get_student_reports_by_student',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							reports_master_list: result['data'],
						});
												
						
					}else{
						this.setState({
							reports_master_list: [],
						});
					}
				}
			}); 	
			
			
	
	}
  }
  
  
		
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){				
		
			this.setState({ loading: true });
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))				
			
             var master_id = [];
             var term1 = [];
             var term2 = [];   
			
			  var form_count = document.getElementsByName('master_id[]');     
			 
			 for (var i = 0; i < form_count.length; i++) {
				master_id[i] = document.getElementsByName('master_id[]')[i].value;
				term1[i] = document.getElementsByName('term1[]')[i].value;
				term2[i] = document.getElementsByName('term2[]')[i].value;				
		     }
			   
			
			var app = {
				school_id : storedArray['data'][0]['school_id'],
				user_id : storedArray['data'][0]['user_id'],
				student_id :  this.props.match.params.id, 
				master_id : master_id,
				term1 : term1,
				term2 : term2,
			}
			getData('fees/add_student_reports_data',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error(result.message,2);
					this.setState({ loading: false });
				}
				if(result.status==200){
					message.config({ top: 150});
					message.success('Reports Data Updated',2);
					this.setState({ loading: false });
					window.location.href = '/student-reports/index';
				}
		  });
	   
	  }
	  else{
			message.error('Please Login',2);	
	  }

  }


	
	
	goBack(){
		window.location.href = '/';
	}
	render()

	{	
	const { size } = this.state;

		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                    
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Student Reports</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Student Rports 
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
			<div class="col s12 m12 ex-padd">
            <div class="container ">
			   <div class="col s12 m12 mb-20 mt-0 card-content iq-card">				
			   
													
											
                  <section class="invoice-list-wrapper section food">
				  
				  
		  
				 
				  <div class="ms-report">
				  
				      {this.state.student_data_details.map((student) => ( 		
					  <div class=" children  bg-color-1 mb-10 iq-card2">	   
					   	 <Collapse className="mb-20" defaultActiveKey={['1']} onChange={callback}>
							<Panel header="Student" classname="as" key="1">

						<div class="card-body">
							<div class="col s12 m6 l6">
						      <p><b>Name :</b>  {student.student_name}</p>
						      <p><b>Class :</b>  {student.program_name}</p>						
						
						    </div>	
						 </div>	
									
									
							</Panel>
						  </Collapse>
						  </div>
				  		))}
				  
				      {this.state.reports_master_list.map((list) => ( 
					  <div class=" children  bg-color-1 mb-10 iq-card2">						   
						 <Collapse defaultActiveKey={['1']} onChange={callback}>
							<Panel header={list.subject} classname="as" key="1">

						<div class="card-body">
							<div class="table-responsive">
							   <table class="table mtb-reports ">
								  <thead>
									 <tr>
										<th  width="60%">{list.subject}</th>
										<th width="20%">TERM 1</th>
										<th width="20%">TERM 2</th>
									 </tr>
								  </thead>
								  <tbody>
									{list.questions.map((row) => (
									  <tr>
										<td>{row.question}
										<input type="hidden" name="master_id[]" defaultValue={row.master_id} />
										</td>
    									 <td>
					

										  <select  class="form" placeholder="Select"  id={`term1_${row.master_id}`}  name="term1[]">
											<option value="0" selected={`${row.term1==0?'selected':''}`}>Select</option>
											<option value="1" selected={`${row.term1==1?'selected':''}`}>Satisfactory</option>
											<option value="2" selected={`${row.term1==2?'selected':''}`}>Good</option>
											<option value="3" selected={`${row.term1==3?'selected':''}`}>Excellent</option>
										 </select>
					
									     </td>	
										 
    									 <td>
										    <select  class="form " placeholder="Select" id={`term2_${row.master_id}`}  name="term2[]">	
												<option value="0" selected={`${row.term2==0?'selected':''}`}>Select</option>
												<option value="1" selected={`${row.term2==1?'selected':''}`}>Satisfactory</option>
												<option value="2" selected={`${row.term2==2?'selected':''}`}>Good</option>
												<option value="3" selected={`${row.term2==3?'selected':''}`}>Excellent</option>
											 </select>
					
							
										 </td>					
									 </tr>
									 ))}									 
									 {(() => {  
											if (list.questions.length =='0') {
											return (
														<p id="error" class="">No Questions Selected</p>
													)
												}
										})()}	
								  </tbody>
							   </table>
							</div>
						 </div>	
									
									
							</Panel>
						  </Collapse>
						  
						  
						</div> 
				  		))}
						
						
								{(() => {  
											if (this.state.reports_master_list.length =='0') {
											return (
														<p id="error" class="">No Data Found</p>
													)
												}
										})()}	
				
					</div>
					
			
					
				
					
				
					<div class="col m12 s12 meal mt-20 mb-20 center">
						 <Button className="cancel-btn btn-lg large-btn" onClick={this.goBack}>Back</Button>
						 <Button className="snd-btn btn-lg large-btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
